import script from "./word.vue?vue&type=script&setup=true&lang=ts"
export * from "./word.vue?vue&type=script&setup=true&lang=ts"

import "./word.vue?vue&type=style&index=0&id=5f949138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f949138"]])

export default __exports__